import { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./love-match-enter-style.css";
import GenderMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import StatusMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import BirthTimeMenu from "../../../dialog/default-menu/DefaultMenuDialog";
import CalenderPicker from "../../../dialog/calender/calender-picker";
import ClockPicker from "../../../dialog/clock/clock-picker";
import BirthplacePicker from "../../../dialog/birthplace-picker/birthplace-picker";
import Loading from "../../../dialog/loading/loading";
import GoogleLoginDialog from "../../../dialog/google-login/GoogleLoginDialog";
import ConfirmDialog from "../../../dialog/confirm/confirm-dialog";
import Menulist from "../../../../constant/menulist";
import useIsMobile from "../../../../hooks/useIsMobile";
import AuthService from "../../../../service/auth-service";
import UserService from "../../../../service/user-service";
import ProductService from "../../../../service/product-service";
import SiteFooter from "../../../custom/site-footer/site-footer";
import PageSeo from "../../../custom/page-seo/page-seo";
import { trackPurchase } from "../../../../utils/meta-pixel";

//—— 從已登入用戶 profile 抽出本人生辰欄位當預設值 ——
//  未登入 / 未完成註冊時回空 obj，state 就用空字串預設
const getSelfPrefill = () => {
  const p = AuthService.getUserProfile();
  if (!p || p.userValidCode !== "2") return {};
  return {
    name: p.userName || "",
    gender: p.userGender || "",
    birthDate: p.userBirthDate || "",
    birthTimeSign: p.userBirthTimeSign || "",
    timeMode: p.timeMode || "0",
    birthClockTime: p.userBirthClockTime || "",
    birthLongitude:
      p.userBirthLongitude != null ? String(p.userBirthLongitude) : "",
    birthLatitude:
      p.userBirthLatitude != null ? String(p.userBirthLatitude) : "",
    birthPlace: p.userBirthPlace || "",
  };
};

const LoveMatchEnterComponent = ({
  setShowServiceMenu,
  setShowPersonalMenu,
}) => {
  //進頁時先讀 profile；若之後透過登入 dialog 才拿到 profile，會在 handleLoginSuccess 補一次
  const _prefill = getSelfPrefill();

  //本人
  const [name, setName] = useState(_prefill.name || "");
  const [gender, setGender] = useState(_prefill.gender || "");
  const [birthDate, setBirthDate] = useState(_prefill.birthDate || "");
  const [birthTimeSign, setBirthTimeSign] = useState(
    _prefill.birthTimeSign || "",
  );
  //本人-真太陽時
  const [selfTimeMode, setSelfTimeMode] = useState(_prefill.timeMode || "0"); //"0" 標準 / "1" 真太陽時
  const [selfBirthClockTime, setSelfBirthClockTime] = useState(
    _prefill.birthClockTime || "",
  );
  const [selfLongitude, setSelfLongitude] = useState(
    _prefill.birthLongitude || "",
  );
  const [selfLatitude, setSelfLatitude] = useState(
    _prefill.birthLatitude || "",
  );

  //對方
  const [otherName, setOtherName] = useState("");
  const [otherGender, setOtherGender] = useState("");
  const [otherBirthDate, setOtherBirthDate] = useState("");
  const [otherBirthTimeSign, setOtherBirthTimeSign] = useState("");
  //對方-真太陽時
  const [partnerTimeMode, setPartnerTimeMode] = useState("0");
  const [partnerBirthClockTime, setPartnerBirthClockTime] = useState("");
  const [partnerLongitude, setPartnerLongitude] = useState("");
  const [partnerLatitude, setPartnerLatitude] = useState("");

  const [lovetatus, setLoveStatus] = useState("");

  const [foucsIndex, setFoucsIndex] = useState(-1);

  const [showOtherGenderMenu, setShowOtherGenderMenu] = useState(false);
  const [showSelfGenderMenu, setShowSelfGenderMenu] = useState(false);
  const [showStatusMenu, setShowStatusMenu] = useState(false);
  const [showSelfBirthTimeMenu, setShowSelfBirthTimeMenu] = useState(false);
  const [showOtherBirthTimeMenu, setShowOtherBirthTimeMenu] = useState(false);
  const [showSelfSunTimeDes, setShowSelfSunTimeDes] = useState(false);
  const [showPartnerSunTimeDes, setShowPartnerSunTimeDes] = useState(false);

  //出生地選擇（一個 dialog、target 決定要填本人還是對方）
  const [showBirthplacePicker, setShowBirthplacePicker] = useState(false);
  const [birthplaceTarget, setBirthplaceTarget] = useState("self");
  const [selfPlaceName, setSelfPlaceName] = useState(
    _prefill.birthPlace || "",
  );
  const [partnerPlaceName, setPartnerPlaceName] = useState("");

  const openBirthplacePicker = (target) => {
    setBirthplaceTarget(target);
    setShowBirthplacePicker(true);
  };

  const handleBirthplaceSelect = ({ fullName, lat, lng }) => {
    if (birthplaceTarget === "self") {
      setSelfPlaceName(fullName || "");
      if (typeof lng === "number") setSelfLongitude(String(lng));
      if (typeof lat === "number") setSelfLatitude(String(lat));
    } else {
      setPartnerPlaceName(fullName || "");
      if (typeof lng === "number") setPartnerLongitude(String(lng));
      if (typeof lat === "number") setPartnerLatitude(String(lat));
    }
  };

  const [navHeight, setNavHeight] = useState(0);
  const [activeTab, setActiveTab] = useState("single");
  const isMobile = useIsMobile();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const nav = document.querySelector(
      isMobile ? ".mobile-dashboard nav" : ".dashboard nav",
    );
    setNavHeight(nav ? nav.offsetHeight : 0);
  }, [isMobile]);

  let navigate = useNavigate();
  let location = useLocation();
  const registerFrom = location.pathname;

  //—— Auth gating（與其他 enter 頁同 pattern）——
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const [showRegisterPrompt, setShowRegisterPrompt] = useState(false);

  const formRef = useRef(null);
  const scrollToForm = () =>
    formRef.current?.scrollIntoView({ behavior: "smooth" });

  const ensureCanInteract = () => {
    const isLogin = AuthService.getLoginStatus();
    const profile = AuthService.getUserProfile();
    if (!isLogin || !profile) {
      setShowLoginDialog(true);
      return false;
    }
    if (profile.userValidCode !== "2") {
      setShowRegisterPrompt(true);
      return false;
    }
    return true;
  };

  //表單區攔截器：未認證就阻止 click / mousedown / focus
  const gateFormEvent = (e) => {
    if (!ensureCanInteract()) {
      e.preventDefault();
      e.stopPropagation();
      if (e.target && typeof e.target.blur === "function") {
        e.target.blur();
      }
    }
  };

  const handleLoginSuccess = async ({ idToken } = {}) => {
    if (!idToken) return;
    try {
      const res = await AuthService.firebaseLogin(idToken);
      if (res.data.status) {
        AuthService.login(res.data.data);
        setShowLoginDialog(false);
        if (res.data.data.userValidCode !== "2") {
          navigate("/register", { state: { from: registerFrom } });
        } else {
          //A-1 沒回生辰欄位，需要再打 B-1 拿完整 profile 才能勾自己那側的預設值
          try {
            const infoRes = await UserService.getPersonalInfo();
            if (infoRes.data?.status) {
              AuthService.updateUserInfo(infoRes.data.data);
            }
          } catch (err) {
            console.error("[LoveMatchEnter] 拉 personal-info 失敗:", err);
          }
          const fresh = getSelfPrefill();
          setName(fresh.name || "");
          setGender(fresh.gender || "");
          setBirthDate(fresh.birthDate || "");
          setBirthTimeSign(fresh.birthTimeSign || "");
          setSelfTimeMode(fresh.timeMode || "0");
          setSelfBirthClockTime(fresh.birthClockTime || "");
          setSelfLongitude(fresh.birthLongitude || "");
          setSelfLatitude(fresh.birthLatitude || "");
          setSelfPlaceName(fresh.birthPlace || "");
        }
      }
    } catch (e) {
      console.error("[LoveMatchEnter] firebase-login 失敗:", e);
    }
  };

  //付款流程用：待產生報告的訂單編號 + 是否正在輪詢（防重複啟動）
  //  orderID 從 /checkout 導回時透過 location.state.pendingOrderID 帶過來
  const pendingOrderIdRef = useRef(location.state?.pendingOrderID || null);
  const pollingRef = useRef(false);

  //判斷註冊表單的資料是否填齊備
  //  timeMode="0" 標準時：只要 sign；timeMode="1" 真太陽時：要 clockTime + 經緯度
  const isFormComplete = Boolean(
    name.trim() &&
    gender &&
    birthDate &&
    (selfTimeMode === "0"
      ? birthTimeSign
      : selfBirthClockTime && selfLongitude && selfLatitude) &&
    otherName.trim() &&
    otherGender &&
    otherBirthDate &&
    (partnerTimeMode === "0"
      ? otherBirthTimeSign
      : partnerBirthClockTime && partnerLongitude && partnerLatitude) &&
    lovetatus,
  );

  const GENDER_MAP = Menulist.genderMap;
  const LOVE_STATUS_MAP = Menulist.loveStatusMap;
  //出生時辰選單：自己一定要填確切時辰（12 個時辰）；對方那邊額外多一個「不知道時辰」（sign = "unknown"，後端會當作午時折衷時間 12:01）
  const SELF_BIRTH_TIME_MAP = { ...Menulist.birthTimeMap };
  const OTHER_BIRTH_TIME_MAP = {
    ...Menulist.birthTimeMap,
    unknown: "不知道時辰",
  };

  //按「購買」→ 導 /checkout 選發票 → /checkout 建單、跳綠界，並導回本頁帶 pendingOrderID
  //  用戶從綠界付款分頁切回本頁時，下面的 visibilitychange 就會開始輪詢報告
  const handlePurchase = () => {
    if (!isFormComplete) return;
    const isSelfSun = selfTimeMode === "1";
    const isPartnerSun = partnerTimeMode === "1";
    navigate("/checkout", {
      state: {
        planID: "digital_love",
        itemName: "真愛合盤解析",
        amount: 599,
        payload: {
          //本人（timeMode="0" 送 sign；timeMode="1" 送 clockTime + 經緯度）
          selfName: name.trim(),
          selfGender: gender,
          selfBirth: birthDate,
          selfTimeMode,
          selfBirthTimeSign: isSelfSun ? "" : birthTimeSign,
          selfBirthClockTime: isSelfSun ? selfBirthClockTime : "",
          selfLongitude: isSelfSun ? String(selfLongitude) : "",
          selfLatitude: isSelfSun ? String(selfLatitude) : "",
          //對方
          partnerName: otherName.trim(),
          partnerGender: otherGender,
          partnerBirth: otherBirthDate,
          partnerTimeMode,
          partnerBirthTimeSign: isPartnerSun ? "" : otherBirthTimeSign,
          partnerBirthClockTime: isPartnerSun ? partnerBirthClockTime : "",
          partnerLongitude: isPartnerSun ? String(partnerLongitude) : "",
          partnerLatitude: isPartnerSun ? String(partnerLatitude) : "",
          status: lovetatus,
        },
        returnPath: location.pathname,
      },
    });
  };

  //付款分頁切回來時：輪詢「綠界 callback 是否已被後端確認（paid=true）」
  //  一確認付款（不必等 AI 跑完）就直接導 /study-room，使用者立刻看到「分析中」的書
  //  AI 跑完後書房卡片會自動切「分析中...」→「查看內容」（study-room-page 自己 poll）
  useEffect(() => {
    const startPolling = async (orderId) => {
      if (pollingRef.current) return;
      pollingRef.current = true;
      setIsLoading(true);

      //輪詢付款確認的上限：通常綠界 callback 30 秒內就會打回來，給 2 分鐘 buffer
      const MAX_TRIES = 48; //× 2.5 秒 = 2 分鐘
      const INTERVAL_MS = 2500;

      for (let i = 0; i < MAX_TRIES; i++) {
        if (pendingOrderIdRef.current !== orderId) break;
        try {
          const res = await ProductService.getLoveReportByOrder(orderId);
          const d = res.data?.data;
          //paid=true 就跳轉（不必等 ready；分析中 / 已完成 / 失敗都各自在書房有對應 UI）
          if (res.data?.status && d?.paid) {
            //Meta Pixel Purchase 事件（帶 orderID 跟後端 CAPI 去重）
            trackPurchase({
              productID: "digital_love",
              productName: "愛情合盤",
              amount: 599,
              orderID: orderId,
            });
            pendingOrderIdRef.current = null;
            pollingRef.current = false;
            setIsLoading(false);
            navigate("/study-room");
            return;
          }
        } catch (e) {
          console.log(e);
        }
        await new Promise((r) => setTimeout(r, INTERVAL_MS));
      }

      //輪詢超時：付款 callback 沒收到，使用者可能根本沒付款 / 綠界異常
      //  保險導去 /study-room：有付款就看到新書、沒付款就看到原本的列表
      pendingOrderIdRef.current = null;
      pollingRef.current = false;
      setIsLoading(false);
      navigate("/study-room");
    };

    const onVisible = () => {
      if (
        document.visibilityState === "visible" &&
        pendingOrderIdRef.current &&
        !pollingRef.current
      ) {
        startPolling(pendingOrderIdRef.current);
      }
    };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [navigate]);

  const closeAllMenus = () => {
    setShowOtherGenderMenu(false);
    setShowSelfGenderMenu(false);
    setShowStatusMenu(false);
    setShowSelfBirthTimeMenu(false);
    setShowOtherBirthTimeMenu(false);
    setShowSelfSunTimeDes(false);
    setShowPartnerSunTimeDes(false);
  };

  return (
    <div className="love-match-enter-page">
      <PageSeo
        title="真愛合盤｜八字緣分配對"
        description="兩人八字合盤分析，看清關係的張力、互補與長期相處模式。分交往前、交往中兩種版型，解讀感情中的真實課題。"
        path="/love-enter"
      />
      {/* 產生合盤報告中（呼叫 Gemini，約十幾秒）*/}
      {isLoading && <Loading />}


      {/* 未登入訪客點到表單時跳出；關掉 → 留在當前頁 */}
      {showLoginDialog && (
        <GoogleLoginDialog
          open={showLoginDialog}
          onClose={() => {
            setShowLoginDialog(false);
          }}
          onSuccess={handleLoginSuccess}
        />
      )}

      {/* 已登入但未完成註冊；關掉 → 留在當前頁 */}
      <ConfirmDialog
        open={showRegisterPrompt}
        onClose={() => {
          setShowRegisterPrompt(false);
        }}
        onSuccess={() => {
          setShowRegisterPrompt(false);
          navigate("/register", { state: { from: registerFrom } });
        }}
        title="尚未完成註冊"
        message="填寫真愛合盤資料前需完成註冊，<br>是否前往註冊頁完成？"
        confirmTxt="前往註冊"
      />

      {!isMobile && (
        <main
          className="web-main"
          style={{ paddingTop: navHeight }}
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={closeAllMenus}
        >
          <img
            className="banner"
            src={`/images/bg-love-web-banner.png`}
            loading="lazy"
            alt="真愛合盤"
            onClick={scrollToForm}
          />

          <div className="first-block">
            <p>
              無論是曖昧中，還是已經在一起
              <br />
              用命盤看懂你們的吸引、磨合與未來可能性
            </p>
            <img
              className="question-icon"
              src={`/images/ic-question-mark.png`}
              alt="?"
            />
            <p className="section-title">很多人其實都卡在這裡：</p>
            <div className="trouble-cards">
              <div className="trouble-card">
                <div className="tag">
                  <span className="emoji">💬</span>
                  <span>曖昧中</span>
                </div>
                <div className="questions">
                  <p>他到底是不是認真的？</p>
                  <p>我們有沒有機會在一起？</p>
                </div>
              </div>
              <div className="trouble-card">
                <div className="tag">
                  <span className="emoji">❤️</span>
                  <span>交往中</span>
                </div>
                <div className="questions">
                  <p>為什麼總是常常吵架？</p>
                  <p>這段關係能不能走長久？</p>
                </div>
              </div>
            </div>
          </div>

          <div className="second-block">
            <p>用命盤解析你們之間的吸引力、適合度與未來走向</p>
            <p>你以為是感情問題，其實是看不清關係本質</p>
          </div>

          <div className="third-block">
            <p className="title">愛情最消耗的不是付出，而是不確定</p>
            <p className="sub-title">一份報告，看清「現在＋未來」</p>
            <div className="tell-card">
              <div className="inner-tell-card">
                <p className="tell-title">我們會告訴你</p>
                <p className="tell-answer">
                  <span className="highlight">解析對方對感情的態度</span>
                </p>
                <p className="tell-answer">
                  <span className="highlight">你們會出現的相處與衝突</span>
                </p>
                <p className="tell-answer">
                  <span className="highlight">
                    未來適合繼續並調整，還是停下
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="fourth-block" ref={formRef}>
            <img
              src={`/images/ic-love-report.png`}
              loading="lazy"
              alt="真愛合盤"
            />
            <p className="slogan">
              現在就輸入彼此出生日期
              <br />
              立即解析你們的關係
            </p>

            <div
              className="love-input-card"
              onMouseDownCapture={gateFormEvent}
              onClickCapture={gateFormEvent}
              onFocusCapture={gateFormEvent}
            >
              {/*你的姓名*/}
              <div
                className={`item-info ${foucsIndex == 0 ? "foucs" : "non-focus"}`}
              >
                <p>你的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setFoucsIndex(0)}
                />
              </div>

              {/*你的性別選單*/}
              <div
                className={`item-info menu ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowOtherGenderMenu(false);
                  setShowStatusMenu(false);
                  setShowSelfGenderMenu(!showSelfGenderMenu);
                }}
              >
                <p>你的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[gender]}
                  onFocus={() => setFoucsIndex(1)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showSelfGenderMenu && (
                  <div className="float-menu">
                    <GenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setGender(g)}
                      onClose={() => setShowSelfGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              {/*你的出生日期日曆*/}
              <div
                className={`item-info ${foucsIndex == 2 ? "foucs" : "non-focus"}`}
              >
                <p>你的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={birthDate}
                    setBirthDate={setBirthDate}
                    onFocus={() => setFoucsIndex(2)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              {/*本人：標準時間 / 真太陽時 切換*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="self-method"
                    id="self-standard"
                    value="standard"
                    checked={selfTimeMode === "0"}
                    onChange={() => setSelfTimeMode("0")}
                  />
                  <label htmlFor="self-standard">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="self-method"
                    id="self-sun"
                    value="sun"
                    checked={selfTimeMode === "1"}
                    onChange={() => setSelfTimeMode("1")}
                  />
                  <label htmlFor="self-sun">真太陽時</label>
                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowSelfSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showSelfSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*本人-標準時間：出生時辰選單*/}
              {selfTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSelfGenderMenu(false);
                    setShowOtherGenderMenu(false);
                    setShowStatusMenu(false);
                    setShowOtherBirthTimeMenu(false);
                    setShowSelfBirthTimeMenu(!showSelfBirthTimeMenu);
                  }}
                >
                  <p>你的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    readOnly
                    value={SELF_BIRTH_TIME_MAP[birthTimeSign]}
                    onFocus={() => setFoucsIndex(7)}
                  />
                  <img src="../images/ic-brown-down.png" alt="" />
                  {showSelfBirthTimeMenu && (
                    <div className="float-menu">
                      <BirthTimeMenu
                        dataMap={SELF_BIRTH_TIME_MAP}
                        onSuccess={(sign) => setBirthTimeSign(sign)}
                        onClose={() => setShowSelfBirthTimeMenu(false)}
                      />
                    </div>
                  )}
                </div>
              )}

              {/*本人-真太陽時：時辰 + 出生地選擇 + 經緯度*/}
              {selfTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 20 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>你的出生時辰</p>
                    <ClockPicker
                      clockTime={selfBirthClockTime}
                      setClockTime={setSelfBirthClockTime}
                      onFocus={() => setFoucsIndex(20)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    className={`item-info menu ${foucsIndex == 21 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(21);
                      openBirthplacePicker("self");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇你的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "2.5rem",
                        fontSize: "1.1rem",
                        color: selfPlaceName ? undefined : "rgba(198, 198, 198)",
                      }}
                    >
                      {selfPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex == 22 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={selfLongitude}
                        onChange={(e) => setSelfLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(22)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex == 23 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-90"
                        max="90"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        value={selfLatitude}
                        onChange={(e) => setSelfLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(23)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/*本人 / 對方 分隔線*/}
              <div
                style={{
                  height: "1px",
                  background: "rgba(0, 0, 0, 0.08)",
                  margin: "0.5rem 0 1.5rem 0",
                }}
              />

              {/*對方的姓名*/}
              <div
                className={`item-info ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
              >
                <p>對方的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={otherName}
                  onChange={(e) => setOtherName(e.target.value)}
                  onFocus={() => setFoucsIndex(3)}
                />
              </div>

              {/*對方的性別選單*/}
              <div
                className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(false);
                  setShowStatusMenu(false);
                  setShowOtherGenderMenu(!showOtherGenderMenu);
                }}
              >
                <p>對方的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[otherGender]}
                  onFocus={() => setFoucsIndex(4)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showOtherGenderMenu && (
                  <div className="float-menu">
                    <GenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setOtherGender(g)}
                      onClose={() => setShowOtherGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              {/*對方的出生日期日曆*/}
              <div
                className={`item-info ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
              >
                <p>對方的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={otherBirthDate}
                    setBirthDate={setOtherBirthDate}
                    onFocus={() => setFoucsIndex(5)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              {/*對方：標準時間 / 真太陽時 切換*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="partner-method"
                    id="partner-standard"
                    value="standard"
                    checked={partnerTimeMode === "0"}
                    onChange={() => setPartnerTimeMode("0")}
                  />
                  <label htmlFor="partner-standard">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="partner-method"
                    id="partner-sun"
                    value="sun"
                    checked={partnerTimeMode === "1"}
                    onChange={() => setPartnerTimeMode("1")}
                  />
                  <label htmlFor="partner-sun">真太陽時</label>
                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowPartnerSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showPartnerSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*對方-標準時間：出生時辰選單*/}
              {partnerTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex == 8 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSelfGenderMenu(false);
                    setShowOtherGenderMenu(false);
                    setShowStatusMenu(false);
                    setShowSelfBirthTimeMenu(false);
                    setShowOtherBirthTimeMenu(!showOtherBirthTimeMenu);
                  }}
                >
                  <p>對方的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    readOnly
                    value={OTHER_BIRTH_TIME_MAP[otherBirthTimeSign]}
                    onFocus={() => setFoucsIndex(8)}
                  />
                  <img src="../images/ic-brown-down.png" alt="" />
                  {showOtherBirthTimeMenu && (
                    <div className="float-menu">
                      <BirthTimeMenu
                        dataMap={OTHER_BIRTH_TIME_MAP}
                        onSuccess={(sign) => setOtherBirthTimeSign(sign)}
                        onClose={() => setShowOtherBirthTimeMenu(false)}
                      />
                    </div>
                  )}
                </div>
              )}

              {/*對方-真太陽時：時辰 + 出生地選擇 + 經緯度*/}
              {partnerTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 24 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>對方的出生時辰</p>
                    <ClockPicker
                      clockTime={partnerBirthClockTime}
                      setClockTime={setPartnerBirthClockTime}
                      onFocus={() => setFoucsIndex(24)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    className={`item-info menu ${foucsIndex == 25 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(25);
                      openBirthplacePicker("partner");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇對方的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "2.5rem",
                        fontSize: "1.1rem",
                        color: partnerPlaceName
                          ? undefined
                          : "rgba(198, 198, 198)",
                      }}
                    >
                      {partnerPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex == 26 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={partnerLongitude}
                        onChange={(e) => setPartnerLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(26)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex == 27 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-90"
                        max="90"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        value={partnerLatitude}
                        onChange={(e) => setPartnerLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(27)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/*你們目前的狀態為*/}
              <div
                className={`item-info menu ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(false);
                  setShowOtherGenderMenu(false);
                  setShowStatusMenu(!showStatusMenu);
                }}
              >
                <p>你們目前的狀態為</p>
                <input
                  className="input-block"
                  placeholder="尚未交往/交往中"
                  readOnly
                  value={LOVE_STATUS_MAP[lovetatus]}
                  onFocus={() => setFoucsIndex(6)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showStatusMenu && (
                  <div className="float-menu">
                    <StatusMenu
                      dataMap={LOVE_STATUS_MAP}
                      onSuccess={(status) => setLoveStatus(status)}
                      onClose={() => setShowStatusMenu(false)}
                    />
                  </div>
                )}
              </div>

              <button
                className={isFormComplete && !isLoading ? "active" : "disabled"}
                disabled={!isFormComplete || isLoading}
                onClick={handlePurchase}
              >
                獲取真愛合盤 NT$599
              </button>
            </div>

            <div className="bonus">
              <img
                src={`/images/ic-bonus-star.png`}
                loading="lazy"
                alt="額外加贈"
              />
              <span className="label">額外加贈</span>
              <span className="bonus-content">合盤諮詢 1 次</span>
            </div>

            <p className="expert-hint">
              對真愛合盤的內容還有問題想問嗎？
              <br />
              透過專業諮詢去提問，大師將會親自回覆您！
            </p>
          </div>

          <div className="fifth-block">
            <span>
              感情最怕的不是遇到錯的人
              <br />
              而是太晚才發現這段感情不值得
            </span>
          </div>

          <div className="sixth-block">
            <img src={`/images/ic-more-stars.png`} loading="lazy" alt="" />
            <p className="tell">真愛合盤解析內容</p>
            <div className="tab-switch">
              <div
                className={`tab ${activeTab === "single" ? "active" : ""}`}
                onClick={() => setActiveTab("single")}
              >
                尚未交往
              </div>
              <div
                className={`tab ${activeTab === "dating" ? "active" : ""}`}
                onClick={() => setActiveTab("dating")}
              >
                交往中
              </div>
            </div>

            {activeTab === "single" && (
              <div className="tab-content">
                <p className="tab-desc">你會看懂這段關係「該不該開始」</p>
                <p className="tab-hint">
                  👉 適合：曖昧中、剛認識、有好感但不確定的人
                </p>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">1</span>
                    <span>｜</span>
                    <span className="title">你可能喜歡的類型</span>
                  </div>
                  <div className="item-sub">
                    <span>你最容易被什麼樣的人吸引？</span>
                    <span>你內心真正喜歡的，又是什麼樣的人？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">2</span>
                    <span>｜</span>
                    <span className="title">對方個性分析</span>
                  </div>
                  <div className="item-sub">
                    <span>他表現出來的樣子，是真的嗎？</span>
                    <span>內心是慢熱、防備，還是其實很需要愛？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">3</span>
                    <span>｜</span>
                    <span className="title">對感情的態度與行為</span>
                  </div>
                  <div className="item-sub">
                    <span>他是會認真投入的人，還是隨緣型？</span>
                    <span>他的實際付出，應該會是怎麼樣的？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">4</span>
                    <span>｜</span>
                    <span className="title">互相吸引的原因</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      為什麼你們會互相吸引？
                      <br />
                      這股吸引力是短暫激情，還是深層契合？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">5</span>
                    <span>｜</span>
                    <span className="title">你們的速配程度 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      不只是有沒有感覺，而是適不適合
                      <br />
                      ◆ 價值觀契合度
                      <br />
                      ◆ 誰主導關係？誰容易付出多？
                      <br />
                      ◆ 溝通上是否有問題
                      <br />
                      ◆ 金錢與現實觀差異
                      <br />◆ 幫你判斷：值不值得開始
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">6</span>
                    <span>｜</span>
                    <span className="title">交往後的相處＋潛在衝突 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      如果真的在一起，會卡在哪裡？
                      <br />
                      哪些地方要特別注意？
                      <br />
                      該怎麼化解才能相處更長久？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">7</span>
                    <span>｜</span>
                    <span className="title">戀愛體質雷達圖</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      一眼看懂你們的愛情模式：
                      <br />
                      ◆ 穩定度
                      <br />
                      ◆ 浪漫程度
                      <br />
                      ◆ 理性 vs 感性
                      <br />
                      ◆ 依賴程度
                      <br />◆ 金錢觀
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">8</span>
                    <span>｜</span>
                    <span className="title">結語總整理</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      幫你釐清：
                      <br />
                      ◆ 命理上你們合不合適
                      <br />
                      ◆ 彼此相處會是怎麼樣的
                      <br />◆ 你們的感情將會如何
                    </span>
                    <span className="end-sub">
                      👉 👉「在開始之前，就看清楚」
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "dating" && (
              <div className="tab-content">
                <p className="tab-desc">
                  你會看懂這段關係「為什麼會這樣、該怎麼走下去」
                </p>
                <p className="tab-hint">
                  👉 適合：交往中、磨合期、關係卡住的人
                </p>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">1</span>
                    <span>｜</span>
                    <span className="title">雙方個性分析</span>
                  </div>
                  <div className="item-sub">
                    <span>為什麼你們會有這些差異？</span>
                    <span>誰比較理性？誰比較情緒化？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">2</span>
                    <span>｜</span>
                    <span className="title">溝通模式與互動方式 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      為什麼常常講不通？
                      <br />
                      是表達方式不同，還是理解落差？
                      <br />
                      你們該如何調整會更好？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">3</span>
                    <span>｜</span>
                    <span className="title">吵架點分析 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      你們最容易因為什麼起衝突？
                      <br />
                      是價值觀？情緒？還是期待不同？
                      <br />
                      你們的調停模式建議
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">4</span>
                    <span>｜</span>
                    <span className="title">彼此的感情真實需求</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      解開「為什麼總覺得不被理解」
                      <br />
                      ◆ 他真正需要的是什麼？
                      <br />◆ 你需要的，對方有沒有給到？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">5</span>
                    <span>｜</span>
                    <span className="title">如何穩定走長期 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      你們的長期穩定度？
                      <br />
                      這段關係要長久，需要調整什麼？
                      <br />
                      給你「可以做到」的具體建議
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">6</span>
                    <span>｜</span>
                    <span className="title">戀愛合拍指數 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      從命盤客觀分析你們的匹配程度：
                      <br />
                      ◆ 價值觀契合度
                      <br />
                      ◆ 誰主導關係？誰容易付出多？
                      <br />
                      ◆ 溝通上是否有問題
                      <br />
                      ◆ 金錢與現實觀差異
                      <br />◆ 幫你判斷：值不值得開始
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">7</span>
                    <span>｜</span>
                    <span className="title">戀愛體質雷達圖</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      看清你們在愛情中的角色差異：
                      <br />
                      ◆ 穩定度
                      <br />
                      ◆ 浪漫程度
                      <br />
                      ◆ 理性 vs 感性
                      <br />
                      ◆ 依賴程度
                      <br />◆ 金錢觀
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">8</span>
                    <span>｜</span>
                    <span className="title">結語總整理</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      幫你釐清：
                      <br />
                      ◆ 可以繼續經營
                      <br />
                      ◆ 或需要調整模式
                      <br />◆ 還是該重新思考關係
                    </span>
                    <span className="end-sub">
                      👉 👉「好的關係，是可以被理解與調整的」
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="seventh-block">
            <p>不管現在在哪個階段，都值得看清楚</p>
            <span onClick={scrollToForm}>現在就查看你們的關係答案</span>
          </div>

          <SiteFooter />
        </main>
      )}

      {isMobile && (
        <main
          className="mobile-main"
          style={{ paddingTop: navHeight }}
          onMouseEnter={() => {
            setShowServiceMenu(false);
            setShowPersonalMenu(false);
          }}
          onClick={closeAllMenus}
        >
          <img
            className="banner"
            src={`/images/bg-love-mobile-banner.png`}
            loading="lazy"
            alt="真愛合盤"
            onClick={scrollToForm}
          />

          <div className="first-block">
            <p>
              無論是曖昧中，還是已經在一起
              <br />
              用命盤看懂你們的吸引、磨合與未來可能性
            </p>
            <img
              className="question-icon"
              src={`/images/ic-question-mark.png`}
              alt="?"
            />
            <p className="section-title">很多人其實都卡在這裡：</p>
            <div className="trouble-cards">
              <div className="trouble-card">
                <div className="tag">
                  <span className="emoji">💬</span>
                  <span>曖昧中</span>
                </div>
                <div className="questions">
                  <p>他到底是不是認真的？</p>
                  <p>我們有沒有機會在一起？</p>
                </div>
              </div>
              <div className="trouble-card">
                <div className="tag">
                  <span className="emoji">❤️</span>
                  <span>交往中</span>
                </div>
                <div className="questions">
                  <p>為什麼總是常常吵架？</p>
                  <p>這段關係能不能走長久？</p>
                </div>
              </div>
            </div>
          </div>

          <div className="second-block">
            <p>用命盤解析你們之間的吸引力、適合度與未來走向</p>
            <p>你以為是感情問題，其實是看不清關係本質</p>
          </div>

          <div className="third-block">
            <p className="title">
              愛情最消耗的<br></br>不是付出，而是不確定
            </p>
            <p className="sub-title">一份報告，看清「現在＋未來」</p>
            <div className="tell-card">
              <div className="inner-tell-card">
                <p className="tell-title">我們會告訴你</p>
                <p className="tell-answer">
                  <span className="highlight">解析對方對感情的態度</span>
                </p>
                <p className="tell-answer">
                  <span className="highlight">你們會出現的相處與衝突</span>
                </p>
                <p className="tell-answer">
                  <span className="highlight">
                    未來適合繼續並調整，還是停下
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div className="fourth-block" ref={formRef}>
            <img
              src={`/images/ic-love-report.png`}
              loading="lazy"
              alt="真愛合盤"
            />
            <p className="slogan">
              現在就輸入彼此出生日期
              <br />
              立即解析你們的關係
            </p>

            <div
              className="love-input-card"
              onMouseDownCapture={gateFormEvent}
              onClickCapture={gateFormEvent}
              onFocusCapture={gateFormEvent}
            >
              <div
                className={`item-info ${foucsIndex == 0 ? "foucs" : "non-focus"}`}
              >
                <p>你的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onFocus={() => setFoucsIndex(0)}
                />
              </div>

              <div
                className={`item-info menu ${foucsIndex == 1 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowOtherGenderMenu(false);
                  setShowStatusMenu(false);
                  setShowSelfGenderMenu(!showSelfGenderMenu);
                }}
              >
                <p>你的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[gender]}
                  onFocus={() => setFoucsIndex(1)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showSelfGenderMenu && (
                  <div className="float-menu">
                    <GenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setGender(g)}
                      onClose={() => setShowSelfGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info ${foucsIndex == 2 ? "foucs" : "non-focus"}`}
              >
                <p>你的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={birthDate}
                    setBirthDate={setBirthDate}
                    onFocus={() => setFoucsIndex(2)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              {/*本人：標準時間 / 真太陽時 切換（mobile）*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="self-method-m"
                    id="self-standard-m"
                    value="standard"
                    checked={selfTimeMode === "0"}
                    onChange={() => setSelfTimeMode("0")}
                  />
                  <label htmlFor="self-standard-m">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="self-method-m"
                    id="self-sun-m"
                    value="sun"
                    checked={selfTimeMode === "1"}
                    onChange={() => setSelfTimeMode("1")}
                  />
                  <label htmlFor="self-sun-m">真太陽時</label>
                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowSelfSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showSelfSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {selfTimeMode === "0" && (
                <div
                  className={`item-info menu ${foucsIndex == 7 ? "foucs" : "non-focus"}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSelfGenderMenu(false);
                    setShowOtherGenderMenu(false);
                    setShowStatusMenu(false);
                    setShowOtherBirthTimeMenu(false);
                    setShowSelfBirthTimeMenu(!showSelfBirthTimeMenu);
                  }}
                >
                  <p>你的出生時辰</p>
                  <input
                    className="input-block"
                    placeholder="早子時 00:00-00:59"
                    readOnly
                    value={SELF_BIRTH_TIME_MAP[birthTimeSign]}
                    onFocus={() => setFoucsIndex(7)}
                  />
                  <img src="../images/ic-brown-down.png" alt="" />
                  {showSelfBirthTimeMenu && (
                    <div className="float-menu">
                      <BirthTimeMenu
                        dataMap={SELF_BIRTH_TIME_MAP}
                        onSuccess={(sign) => setBirthTimeSign(sign)}
                        onClose={() => setShowSelfBirthTimeMenu(false)}
                      />
                    </div>
                  )}
                </div>
              )}

              {selfTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 20 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>你的出生時辰</p>
                    <ClockPicker
                      clockTime={selfBirthClockTime}
                      setClockTime={setSelfBirthClockTime}
                      onFocus={() => setFoucsIndex(20)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    className={`item-info menu ${foucsIndex == 21 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(21);
                      openBirthplacePicker("self");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇你的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "1rem",
                        fontSize: "0.95rem",
                        color: selfPlaceName ? undefined : "rgba(198, 198, 198)",
                      }}
                    >
                      {selfPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex == 22 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={selfLongitude}
                        onChange={(e) => setSelfLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(22)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex == 23 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-90"
                        max="90"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        value={selfLatitude}
                        onChange={(e) => setSelfLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(23)}
                      />
                    </div>
                  </div>
                </div>
              )}

              {/*本人 / 對方 分隔線（mobile）*/}
              <div
                style={{
                  height: "1px",
                  background: "rgba(0, 0, 0, 0.08)",
                  margin: "0.5rem 0 1.5rem 0",
                }}
              />

              <div
                className={`item-info ${foucsIndex == 3 ? "foucs" : "non-focus"}`}
              >
                <p>對方的姓名</p>
                <input
                  className="input-block"
                  placeholder="請輸入姓名"
                  maxLength={10}
                  value={otherName}
                  onChange={(e) => setOtherName(e.target.value)}
                  onFocus={() => setFoucsIndex(3)}
                />
              </div>

              <div
                className={`item-info menu ${foucsIndex == 4 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(false);
                  setShowStatusMenu(false);
                  setShowOtherGenderMenu(!showOtherGenderMenu);
                }}
              >
                <p>對方的性別</p>
                <input
                  className="input-block"
                  placeholder="請選擇生理性別"
                  readOnly
                  value={GENDER_MAP[otherGender]}
                  onFocus={() => setFoucsIndex(4)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showOtherGenderMenu && (
                  <div className="float-menu">
                    <GenderMenu
                      dataMap={GENDER_MAP}
                      onSuccess={(g) => setOtherGender(g)}
                      onClose={() => setShowOtherGenderMenu(false)}
                    />
                  </div>
                )}
              </div>

              <div
                className={`item-info ${foucsIndex == 5 ? "foucs" : "non-focus"}`}
              >
                <p>對方的出生日期</p>
                <div className="calender">
                  <CalenderPicker
                    birthDate={otherBirthDate}
                    setBirthDate={setOtherBirthDate}
                    onFocus={() => setFoucsIndex(5)}
                  />
                </div>
                <img src="../images/ic-brown-down.png" alt="" />
              </div>

              {/*對方：標準時間 / 真太陽時 切換（mobile）*/}
              <div className="select-radio">
                <div className="option">
                  <input
                    type="radio"
                    name="partner-method-m"
                    id="partner-standard-m"
                    value="standard"
                    checked={partnerTimeMode === "0"}
                    onChange={() => setPartnerTimeMode("0")}
                  />
                  <label htmlFor="partner-standard-m">標準時間</label>
                </div>

                <div className="option suntime">
                  <input
                    type="radio"
                    name="partner-method-m"
                    id="partner-sun-m"
                    value="sun"
                    checked={partnerTimeMode === "1"}
                    onChange={() => setPartnerTimeMode("1")}
                  />
                  <label htmlFor="partner-sun-m">真太陽時</label>
                  <img
                    onClick={(e) => {
                      closeAllMenus();
                      setShowPartnerSunTimeDes(true);
                      e.stopPropagation();
                    }}
                    src="../images/ic-description.png"
                    alt=""
                  />
                  <div className="suntime-tag">
                    {showPartnerSunTimeDes && (
                      <div
                        className="suntime-des"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="title">什麼是真太陽時？</p>
                        <p className="des">
                          真太陽時（True Solar Time）是以天文學算式計算太陽
                          相對地平線的位置的時間，反映某地實際日照狀況。當
                          太陽位於當地子午線上時，即為「真正的中午」。它不同
                          於人為劃分的標準時間，因為地球自轉與公轉的影響，真
                          太陽時會因地點與日期而有所變化，真太陽時則能根據
                          個人的出生經緯度，精確地還原當地的實際時間。
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {partnerTimeMode === "0" && (
              <div
                className={`item-info menu ${foucsIndex == 8 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(false);
                  setShowOtherGenderMenu(false);
                  setShowStatusMenu(false);
                  setShowSelfBirthTimeMenu(false);
                  setShowOtherBirthTimeMenu(!showOtherBirthTimeMenu);
                }}
              >
                <p>對方的出生時辰</p>
                <input
                  className="input-block"
                  placeholder="早子時 00:00-00:59"
                  readOnly
                  value={OTHER_BIRTH_TIME_MAP[otherBirthTimeSign]}
                  onFocus={() => setFoucsIndex(8)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showOtherBirthTimeMenu && (
                  <div className="float-menu">
                    <BirthTimeMenu
                      dataMap={OTHER_BIRTH_TIME_MAP}
                      onSuccess={(sign) => setOtherBirthTimeSign(sign)}
                      onClose={() => setShowOtherBirthTimeMenu(false)}
                    />
                  </div>
                )}
              </div>
              )}

              {partnerTimeMode === "1" && (
                <div>
                  <div
                    className={`item-info menu ${foucsIndex == 24 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      e.stopPropagation();
                    }}
                  >
                    <p>對方的出生時辰</p>
                    <ClockPicker
                      clockTime={partnerBirthClockTime}
                      setClockTime={setPartnerBirthClockTime}
                      onFocus={() => setFoucsIndex(24)}
                    />
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    className={`item-info menu ${foucsIndex == 25 ? "foucs" : "non-focus"}`}
                    onClick={(e) => {
                      closeAllMenus();
                      setFoucsIndex(25);
                      openBirthplacePicker("partner");
                      e.stopPropagation();
                    }}
                  >
                    <p>選擇對方的出生地</p>
                    <span
                      className="input-block"
                      style={{
                        marginLeft: "1rem",
                        fontSize: "0.95rem",
                        color: partnerPlaceName
                          ? undefined
                          : "rgba(198, 198, 198)",
                      }}
                    >
                      {partnerPlaceName || "請選擇"}
                    </span>
                    <img src="../images/ic-brown-down.png" alt="" />
                  </div>

                  <div
                    style={{
                      fontSize: "0.8rem",
                      marginBottom: "1rem",
                      color: "rgb(108, 49, 57)",
                    }}
                  >
                    * 選擇出生地後，將自動帶入該地經緯度
                  </div>

                  <div className="born-place showBlock">
                    <div
                      className={`item-info place ${foucsIndex == 26 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-經度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-180"
                        max="180"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入經度"
                        value={partnerLongitude}
                        onChange={(e) => setPartnerLongitude(e.target.value)}
                        onFocus={() => setFoucsIndex(26)}
                      />
                    </div>
                    <div className="space" />
                    <div
                      className={`item-info place ${foucsIndex == 27 ? "foucs" : "non-focus"}`}
                      onClick={(e) => {
                        closeAllMenus();
                        e.stopPropagation();
                      }}
                    >
                      <p>出生地-緯度</p>
                      <input
                        type="number"
                        className="input-block"
                        min="-90"
                        max="90"
                        step="any"
                        inputMode="decimal"
                        placeholder="請輸入緯度"
                        value={partnerLatitude}
                        onChange={(e) => setPartnerLatitude(e.target.value)}
                        onFocus={() => setFoucsIndex(27)}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div
                className={`item-info menu ${foucsIndex == 6 ? "foucs" : "non-focus"}`}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSelfGenderMenu(false);
                  setShowOtherGenderMenu(false);
                  setShowStatusMenu(!showStatusMenu);
                }}
              >
                <p>你們目前的狀態為</p>
                <input
                  className="input-block"
                  placeholder="尚未交往/交往中"
                  readOnly
                  value={LOVE_STATUS_MAP[lovetatus]}
                  onFocus={() => setFoucsIndex(6)}
                />
                <img src="../images/ic-brown-down.png" alt="" />
                {showStatusMenu && (
                  <div className="float-menu">
                    <StatusMenu
                      dataMap={LOVE_STATUS_MAP}
                      onSuccess={(status) => setLoveStatus(status)}
                      onClose={() => setShowStatusMenu(false)}
                    />
                  </div>
                )}
              </div>

              <button
                className={isFormComplete && !isLoading ? "active" : "disabled"}
                disabled={!isFormComplete || isLoading}
                onClick={handlePurchase}
              >
                獲取真愛合盤 NT$599
              </button>
            </div>

            <div className="bonus">
              <img
                src={`/images/ic-bonus-star.png`}
                loading="lazy"
                alt="額外加贈"
              />
              <span className="label">額外加贈</span>
            </div>
            <span className="bonus-content">合盤諮詢 1 次</span>

            <p className="expert-hint">
              對真愛合盤的內容還有問題想問嗎？
              <br />
              透過專業諮詢去提問，大師將會親自回覆您！
            </p>
          </div>

          <div className="fifth-block">
            <span>
              感情最怕的不是遇到錯的人
              <br />
              而是太晚才發現這段感情不值得
            </span>
          </div>

          <div className="sixth-block">
            <img src={`/images/ic-more-stars.png`} loading="lazy" alt="" />
            <p className="tell">真愛合盤解析內容</p>
            <div className="tab-switch">
              <div
                className={`tab ${activeTab === "single" ? "active" : ""}`}
                onClick={() => setActiveTab("single")}
              >
                尚未交往
              </div>
              <div
                className={`tab ${activeTab === "dating" ? "active" : ""}`}
                onClick={() => setActiveTab("dating")}
              >
                交往中
              </div>
            </div>

            {activeTab === "single" && (
              <div className="tab-content">
                <p className="tab-desc">你會看懂這段關係「該不該開始」</p>
                <p className="tab-hint">
                  👉 適合：曖昧中、剛認識、有好感但不確定的人
                </p>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">1</span>
                    <span>｜</span>
                    <span className="title">你可能喜歡的類型</span>
                  </div>
                  <div className="item-sub">
                    <span>你最容易被什麼樣的人吸引？</span>
                    <span>你內心真正喜歡的，又是什麼樣的人？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">2</span>
                    <span>｜</span>
                    <span className="title">對方個性分析</span>
                  </div>
                  <div className="item-sub">
                    <span>他表現出來的樣子，是真的嗎？</span>
                    <span>內心是慢熱、防備，還是其實很需要愛？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">3</span>
                    <span>｜</span>
                    <span className="title">對感情的態度與行為</span>
                  </div>
                  <div className="item-sub">
                    <span>他是會認真投入的人，還是隨緣型？</span>
                    <span>他的實際付出，應該會是怎麼樣的？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">4</span>
                    <span>｜</span>
                    <span className="title">互相吸引的原因</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      為什麼你們會互相吸引？
                      <br />
                      這股吸引力是短暫激情，還是深層契合？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">5</span>
                    <span>｜</span>
                    <span className="title">你們的速配程度 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      不只是有沒有感覺，而是適不適合
                      <br />
                      ◆ 價值觀契合度
                      <br />
                      ◆ 誰主導關係？誰容易付出多？
                      <br />
                      ◆ 溝通上是否有問題
                      <br />
                      ◆ 金錢與現實觀差異
                      <br />◆ 幫你判斷：值不值得開始
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">6</span>
                    <span>｜</span>
                    <span className="title">交往後的相處＋潛在衝突 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      如果真的在一起，會卡在哪裡？
                      <br />
                      哪些地方要特別注意？
                      <br />
                      該怎麼化解才能相處更長久？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">7</span>
                    <span>｜</span>
                    <span className="title">戀愛體質雷達圖</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      一眼看懂你們的愛情模式：
                      <br />
                      ◆ 穩定度
                      <br />
                      ◆ 浪漫程度
                      <br />
                      ◆ 理性 vs 感性
                      <br />
                      ◆ 依賴程度
                      <br />◆ 金錢觀
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">8</span>
                    <span>｜</span>
                    <span className="title">結語總整理</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      幫你釐清：
                      <br />
                      ◆ 命理上你們合不合適
                      <br />
                      ◆ 彼此相處會是怎麼樣的
                      <br />◆ 你們的感情將會如何
                    </span>
                    <span className="end-sub">
                      👉 👉「在開始之前，就看清楚」
                    </span>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "dating" && (
              <div className="tab-content">
                <p className="tab-desc">
                  你會看懂這段關係「為什麼會這樣、該怎麼走下去」
                </p>
                <p className="tab-hint">
                  👉 適合：交往中、磨合期、關係卡住的人
                </p>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">1</span>
                    <span>｜</span>
                    <span className="title">雙方個性分析</span>
                  </div>
                  <div className="item-sub">
                    <span>為什麼你們會有這些差異？</span>
                    <span>誰比較理性？誰比較情緒化？</span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">2</span>
                    <span>｜</span>
                    <span className="title">溝通模式與互動方式 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      為什麼常常講不通？
                      <br />
                      是表達方式不同，還是理解落差？
                      <br />
                      你們該如何調整會更好？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">3</span>
                    <span>｜</span>
                    <span className="title">吵架點分析 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      你們最容易因為什麼起衝突？
                      <br />
                      是價值觀？情緒？還是期待不同？
                      <br />
                      你們的調停模式建議
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">4</span>
                    <span>｜</span>
                    <span className="title">彼此的感情真實需求</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      解開「為什麼總覺得不被理解」
                      <br />
                      ◆ 他真正需要的是什麼？
                      <br />◆ 你需要的，對方有沒有給到？
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">5</span>
                    <span>｜</span>
                    <span className="title">如何穩定走長期 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      你們的長期穩定度？
                      <br />
                      這段關係要長久，需要調整什麼？
                      <br />
                      給你「可以做到」的具體建議
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">6</span>
                    <span>｜</span>
                    <span className="title">戀愛合拍指數 🔥</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      從命盤客觀分析你們的匹配程度：
                      <br />
                      ◆ 價值觀契合度
                      <br />
                      ◆ 誰主導關係？誰容易付出多？
                      <br />
                      ◆ 溝通上是否有問題
                      <br />
                      ◆ 金錢與現實觀差異
                      <br />◆ 幫你判斷：值不值得開始
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">7</span>
                    <span>｜</span>
                    <span className="title">戀愛體質雷達圖</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      看清你們在愛情中的角色差異：
                      <br />
                      ◆ 穩定度
                      <br />
                      ◆ 浪漫程度
                      <br />
                      ◆ 理性 vs 感性
                      <br />
                      ◆ 依賴程度
                      <br />◆ 金錢觀
                    </span>
                  </div>
                </div>
                <div className="outline">
                  <div className="item-title">
                    <span className="number">8</span>
                    <span>｜</span>
                    <span className="title">結語總整理</span>
                  </div>
                  <div className="item-sub">
                    <span>
                      幫你釐清：
                      <br />
                      ◆ 可以繼續經營
                      <br />
                      ◆ 或需要調整模式
                      <br />◆ 還是該重新思考關係
                    </span>
                    <span className="end-sub">
                      👉 👉「好的關係，是可以被理解與調整的」
                    </span>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="seventh-block">
            <p>不管現在在哪個階段，都值得看清楚</p>
            <span onClick={scrollToForm}>現在就查看你們的關係答案</span>
          </div>

          <SiteFooter />
        </main>
      )}

      {/* 出生地級聯選擇（真太陽時模式下用；target 決定寫給本人還是對方） */}
      <BirthplacePicker
        open={showBirthplacePicker}
        onClose={() => setShowBirthplacePicker(false)}
        onSelect={handleBirthplaceSelect}
      />
    </div>
  );
};

export default LoveMatchEnterComponent;
